export default __webpack_public_path__ + "static/media/button-mini-print.6e092a08.svg";